angular.module('atex.aceui.service').factory('MetadataBranchService', ['$q', 'ContentService',
  function ($q, ContentService) {
    return {
      /**
       * Returns an alias array containing the taxonomy alias IDs of the
       * content in the parent chain of the given content.
       *
       * Returns a promise.
       *
       * If the operation succeeds, the returned promise is resolved with a value like:
       *
       * [
       *   {
       *     id: 'dimension.subjects',
       *     name: 'Subjects'
       *   },
       *
       *   {
       *     id: 'entity1',
       *     name: 'entity1'
       *   },
       *
       *   {
       *     id: 'entity2',
       *     name: 'entity2'
       *   }
       * ]
       *
       * Rejects the returned promise without any value if the operation fails.
       */
      getBranch: function (entity) {
        var deferred = $q.defer();

        var result = [];

        function registerSegment (content) {

          var idPath, namePath, parentPath;

          if (content.content.system.contentType === 'aceDimensionDefinitionContent') {
            idPath = 'content/aspects/aceDimensionDefinition/id';
            namePath = 'content/aspects/aceDimensionDefinition/name';
            parentPath = 'content/aspects/aceDimensionDefinition/parent';
          } else if (content.content.system.contentType === 'aceEntityDefinitionContent') {
            idPath = 'content/aspects/aceEntityDefinition/id';
            namePath = 'content/aspects/aceEntityDefinition/name';
            parentPath = 'content/aspects/aceEntityDefinition/parent';
          } else {
            deferred.reject ();
            return deferred.promise;
          }

          var parent = atex.aceui.ObjectUtils.getByPath(content, parentPath);

          result.unshift({
            id: atex.aceui.ObjectUtils.getByPath(content, idPath),
            name: atex.aceui.ObjectUtils.getByPath(content, namePath)
          });

          if (parent) {
            return ContentService.getContent({ alias: '_taxonomy/' + parent, fullTypeInfo: true })
              .then(registerSegment);
          }

          deferred.resolve(result);
          return deferred.promise;
        }

        return ContentService.getContent({ 'alias': entity.id, fullTypeInfo: true })
          .then(registerSegment);
      }
    };
  }
]);
